<app-page-content header="Projects" subtitle="A look at what we've built.">
  <app-project-card
    client="OneCall Facility Services"
    service="Business website"
    url="https://www.onecallfacilityservices.net/"
  >
    <p class="text-4">
      A website for OneCall Facility Services to showcase their service offerings.
    </p>
  </app-project-card>

  <app-project-card
    client="Sheffield Drive Church of Christ"
    service="Business website"
    url="https://sheffielddrivecoc.org/"
  >
    <p class="text-4">
      A website for Sheffield Drive Church of Christ to connect with their congregation and welcome
      visitors.
    </p>
  </app-project-card>
</app-page-content>
